import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
// import UserList from './components/UserList';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain="dev-e7xysfzjufbbgmwz.us.auth0.com"
    clientId="mheEawRm5jRWXhZjNQHlQo391R85Qwsz"
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >

  {/* <AppProvider> */}
    <App />
    {/* <UserList /> */}
    {/* </AppProvider> */}
    </Auth0Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
